import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subject} from "rxjs";
import {BenefitType, CompanyTaxDistribution} from "../../../../core/helpers/constants";
import {SubscriptionPaymentModel} from "../../../../core/models/subscription-payments";
import {AutoOrderPaymentModel} from "../../../../core/models/auto-order";
import {TaxAndFeesTooltipService} from "../../../../core/service/tax-and-fees-tooltip.service";
import {CoreMediaService} from "../../../../../@core/services/media.service";
import {MediaObserver} from "@angular/flex-layout";
import {TaxService} from "../../../../core/service/tax.service";
import {AuthenticationService} from "../../../../core/service";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-auto-order-payments-table',
  templateUrl: './auto-order-payments-table.component.html',
  styleUrls: ['./auto-order-payments-table.component.scss']
})
export class AutoOrderPaymentsTableComponent implements OnInit, OnChanges {

  private ngUnsubscribe = new Subject<void>();
  public paymentValueTotal = 0;
  public taxesValueTotal = 0;
  public taxDistributionEnm = CompanyTaxDistribution;
  public isMobile = false;

  @Input()
  benefitType: BenefitType;

  @Input()
  benefitTaxCategory: number;

  @Input()
  autoOrderPayments?: AutoOrderPaymentModel[];

  @Input()
  taxDistributionSource: CompanyTaxDistribution;

  taxAndFeesTooltipText: string;
  public showTaxesForCompany: boolean;

  constructor(
    private taxAndFeesService: TaxAndFeesTooltipService,
    private coreMediaService: CoreMediaService,
    private mediaObserver: MediaObserver,
    private taxService: TaxService,
    private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.autoOrderPayments.forEach((payment: AutoOrderPaymentModel) => {
      this.paymentValueTotal += payment.amountWithVat;
      this.taxesValueTotal += payment.taxTotal;
    });
    this.taxAndFeesTooltipText = this.taxAndFeesService.setTaxAndFeesTooltip({
      benefitTaxCategory: this.benefitTaxCategory,
      benefitTypeId: this.benefitType
    }, false);
    this.subscribeToScreenChanges();
    const companyId = this.authenticationService.currentUserValue.companyId;
    this.showTaxesForCompany = !this.taxService.hideTaxes(this.taxDistributionSource, companyId);
  }

  subscribeToScreenChanges() {
    this.coreMediaService.onMediaUpdate.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        const isSmall = this.mediaObserver.isActive('bs-lt-lg');
        this.isMobile = isSmall === true;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.taxesValueTotal = 0;
    this.paymentValueTotal = 0;

    if(changes.payments && !changes.payments.isFirstChange()) {
      this.autoOrderPayments.forEach((payment: AutoOrderPaymentModel) => {
        this.paymentValueTotal += payment.amountWithVat;
        this.taxesValueTotal += payment.taxTotal;
      });
    }
  }
}
